import { createReducer } from 'src/utils/reducer'

const TOGGLE_SAVE = 'TOGGLE_SAVE'
const TOGGLE_RESET = 'TOGGLE_RESET'
const ENABLE_LEVEL = 'ENABLE_LEVEL'
const DISABLE_LEVEL = 'DISABLE_LEVEL'

export const initialRunbookGraphState = {
    isGraphSaved: false,
    isReset: false,
    graphLevel: [],
}

export const toggleSave = () => ({
    type: TOGGLE_SAVE,
})

export const toggleReset = () => ({
    type: TOGGLE_RESET,
})

export const enableLevel = (level) => ({
    type: ENABLE_LEVEL,
    level,
})

export const disableLevel = (level) => ({
    type: DISABLE_LEVEL,
    level,
})

export default createReducer(initialRunbookGraphState, {
    [TOGGLE_SAVE]: (state) => ({
        ...state,
        isGraphSaved: !state.isGraphSaved,
    }),
    [TOGGLE_RESET]: (state) => ({
        ...state,
        isReset: !state.isReset,
    }),
    [ENABLE_LEVEL]: (state, action) => {
        if (!state.graphLevel.includes(action.level)) {
            return {
                ...state,
                graphLevel: [...state.graphLevel, action.level],
            }
        } else {
            return {
                ...state,
            }
        }
    },
    [DISABLE_LEVEL]: (state, action) => {
        if (state.graphLevel.includes(action.level)) {
            return {
                ...state,
                graphLevel: state.graphLevel.filter(
                    (level) => level !== action.level
                ),
            }
        } else {
            return {
                ...state,
            }
        }
    },
})
